import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-waves',
  templateUrl: './fh-svg-waves.component.html',
  styleUrl: './fh-svg-waves.component.scss'
})
export class FhSvgWavesComponent {
  @Input() color: string = '';
  @Input() secondaryColor?: string = '';
}
